<template>
  <div>
    <sui-button color="blue" icon="arrow left" label-position="left" @click="goBack($event, '/')">{{$t('btnBack')}}</sui-button>
    <sui-segment raised>
      <sui-container text-align="center">
        <h2 is="sui-header">{{$t('labelContact')}}</h2>
        LAN1 Hotspots GmbH<br><br>
        Gau&szlig;stra&szlig;e 158<br>
        D-22765 Hamburg<br>
        Tel.:<a href="tel:+49040317666666"> +49 (0)40 317 66 66 66</a><br>
        Fax.:<a href="tel:+49040317666633"> +49 (0)40 317 66 66 33</a><br>
        Mail: <a href="mail:hotline@lan1.de">hotline@lan1.de</a>
        <br />
      </sui-container>
    </sui-segment>
  </div>
</template>

<script>
  export default {
    name: 'Contact',
    metaInfo() {
      return {
        title: this.$t('labelContact'),
        meta: [
          /*{ vmid: 'description', name: 'description', content: this.data.content }*/
        ]
      }
    },
    data() {
      return {
        fromRoute: null
      }
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.fromRoute = from;
      })
    },
    methods: {
      goBack(event, fallback) {
        if (event) {
          event.preventDefault()
        }
        if (this.fromRoute == null || !this.fromRoute.name) {
          this.$router.push(fallback);
        } else {
          this.$router.back();
        }
      }
    },
  };
</script>
